import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'

import France from './France'
import Germany from './Germany'
import Italy from './Italy'
import Spain from './Spain'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
  isItalianLegalEntity: boolean
}

const LegalAndLabour = ({ contractVersion, isItalianLegalEntity }: Props) => {
  const isSpanish = contractVersion.country === 'es'
  const isFrench = contractVersion.country === 'fr'
  const isGerman = contractVersion.country === 'de'

  if (!isSpanish && !isFrench && !isItalianLegalEntity && !isGerman) return <></>

  return (
    <Section icon="academic-cap" title={i18n.t('contract_versions.legal_and_labour.title')}>
      {isSpanish && <Spain contractVersion={contractVersion} />}
      {isFrench && <France contractVersion={contractVersion} />}
      {isItalianLegalEntity && <Italy contractVersion={contractVersion} />}
      {isGerman && <Germany contractVersion={contractVersion} />}
    </Section>
  )
}

export default LegalAndLabour
